module.exports = __webpack_public_path__ + "static/media/img_Inscription_free1@2x.a960593e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_Inscription_free1@2x.png
// module id = 981
// module chunks = 0